import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IDownTimeState } from './downtime.reducer';

const selectFeature = createFeatureSelector<IDownTimeState>('downtime');

export const getDowntimeMessage = createSelector(selectFeature, state => state.downtimeMessage);
export const getDowntimeMessageActionState = createSelector(
  selectFeature,
  state => state.downtimeMessageActionState
);
